import bridge from '../bridge/index'
import { noop } from '../util/lang'
import env from '../core/env'
import { setShare, invokeShare } from './share.driver'

let _initFlag = false // 标记在端内是否已经setShare，否则禁止直接拉起分享面板
const useDBridge = env.is('driver') && !env.is('fusion')
let entranceCfg = {
  buttons: [],
  windowCallBack: '__showEntranceCallBack__'
}

// 目前支持的所有渠道列表
const channelMaps = {
  weixin_timeline: {
    type: 'shareWeixinTimeline',
    name: '微信朋友圈'
  },
  weixin_appmsg: {
    type: 'shareWeixinAppmsg',
    name: '微信好友'
  },
  qzone: {
    type: 'shareQzone',
    name: 'QQ空间'
  },
  qq_appmsg: {
    type: 'shareQqAppmsg',
    name: 'QQ好友'
  },
  alipay_timeline: {
    type: 'shareAlipayLife',
    name: '生活圈'
  },
  alipay_appmsg: {
    type: 'shareAlipayFriend',
    name: '支付宝好友'
  }
}

function parseCfgByChannel (cfg, channel) {
  let data = {}
  // 分享图片类型
  if (cfg.type === 'image') {
    data = {
      type: 'image',
      image: cfg.image
    }
  } else {
    data = {
      url: cfg.url,
      icon: cfg.icon,
      title: cfg[channel + '_title'] || cfg.title,
      content: cfg[channel + '_content'] || cfg.content,
      type: 'text'
    }

    // 小程序  cfg.type == 'miniApp' 统一默认参数
    if (channel === 'weixin_appmsg' && cfg.type === 'miniApp' && cfg.ext) {
      data = Object.assign({}, data, {
        type: cfg.type,
        icon: cfg.shareCardIcon || cfg.icon,
        title: cfg.shareCardContent || cfg.title,
        ext: {
          appId: cfg.ext.appId || '',
          path: cfg.ext.path.replace('_URL_', window.encodeURIComponent(data.url)) || '',
          miniprogramType: cfg.ext.miniprogramType,
          programType: cfg.ext.miniprogramType, // 滴滴要叫programType
          withShareTicket: cfg.ext.withShareTicket
        }
      })
    }
  }
  return data
}

function formatButtons (cfg) {
  let buttons = []

  for (let channel in channelMaps) {
    let channelCfg = channelMaps[channel]

    // 处理需要屏蔽的渠道
    if (cfg[channel] === false) {
      continue
    }

    // 司机端不支持支付宝生活圈 屏蔽之
    if (channel === 'alipay_timeline' && env.is('driver')) {
      continue
    }

    buttons.push({
      type: channelCfg.type,
      name: channelCfg.name,
      data: parseCfgByChannel(cfg, channel)
    })
  }

  if (cfg.refresh !== false) {
    buttons.push({
      type: 'refreshPage',
      name: '刷新'
    })
  }

  return buttons
}

export function setShareInApp (cfg, callback = noop) {
  if (useDBridge) {
    // 司机端使用dbridge设置分享时 api与fusion不同
    setShare(cfg)
  } else {
    setShareCommon(cfg, callback)
  }
}

function setShareCommon (cfg, callback) {
  _initFlag = true

  // 1.禁用分享
  if (cfg === false) {
    entranceCfg.buttons = [{
      name: '刷新',
      type: 'refreshPage'
    }]
    bridge.initEntrance(entranceCfg)
    bridge.showEntrance(entranceCfg, callback)
    return
  }

  // 2.设置分享
  entranceCfg.buttons = formatButtons(cfg)
  window.__showEntranceCallBack__ = function (ret) {
    if (typeof ret === 'string') {
      try {
        ret = JSON.parse(ret)
      } catch (e) {
        ret = {}
      }
    }
    // ret
    // share_result: Number  // -1：需要授权，0：成功，1：失败，2：取消
    // channel: String // wechat
    if (ret.share_result === 0) {
      if (cfg.success) cfg.success(ret)
    } else if (ret.share_result === 2) {
      if (cfg.cancel) cfg.cancel(ret)
    } else {
      if (cfg.fail) cfg.fail(ret)
    }
  }
  bridge.initEntrance(entranceCfg)
  bridge.showEntrance(entranceCfg, callback)
}

export function invokeShareInApp (channel, cfg, callback = noop) {
  if (useDBridge) {
    if (typeof channel !== 'string') {
      // 拉起分享面板
      bridge.invokeEntrance()
    } else {
      // 一键分享
      invokeShare(channel, cfg)
    }
  } else {
    // 1.拉起分享面板
    if (typeof channel !== 'string') {
      callback = typeof cfg === 'function' ? cfg : noop
      cfg = channel

      if (Object.keys(cfg).length === 0) {
        // 为啥不能用initEntrance帮忙init？？？
        // 1.1 传递空params时，如果之前已经调用过K.setShare，则可以直接拉起面板。否则返回错误信息
        if (!_initFlag) {
          callback(`请确保在使用K.invokeShare({},callback)格式掉用之前先调用了K.setShare设置分享面板`)
        } else {
          bridge.invokeEntrance({}, callback)
        }
      } else {
        // 1.2 传递非空params时，如果之前已经调用过K.setShare，则用setShare的信息拉起面板，否则会先进行setShare再拉起面板
        if (_initFlag) {
          bridge.invokeEntrance({}, callback)
        } else {
          setShareInApp(cfg, () => {
            bridge.invokeEntrance({}, callback)
          })
        }
      }
    } else {
      // 2.一键分享，不走分享面板
      let bridgeMethod = channelMaps[channel].type
      if (bridgeMethod in bridge) {
        bridge[bridgeMethod](parseCfgByChannel(cfg, channel), callback)
      }
    }
  }
}
